/* eslint-disable no-use-before-define */
/* eslint-disable import/no-named-default */
import React from 'react'
import { default as lodash } from 'lodash'

import styles from './styles'

const infos = {
  options: {
    fields: {
      child_process: {
        name: 'Processos',
        fields: {
          process_number: 'Número do Processo',
          process_kind: 'Tipo',
          process_class: 'Classe',
          distribution_date: 'Data da Distribuição',
          'applicants.0.name': 'Apelante(s)',
          'applicants.1.name': 'Apelado(a)(s)',
        },
      },
    },
  },
}

const ProcessRow = ({ title, otherInfos }) => {
  const classes = styles()

  const renderOtherInfos = () => {
    if (
      lodash
        .chain(otherInfos)
        .pick(lodash.keys(lodash.get(infos.options, 'fields')))
        .every(lodash.isEmpty)
        .value()
    ) {
      return null
    }

    const renderFields = (item, optFields) => {
      return lodash.map(optFields, (val, key) => (
        <div key={key}>{renderField(item, val, key)}</div>
      ))
    }

    const renderField = (item, fieldVal, fieldKey) => {
      const content = lodash.get(item, fieldKey)

      if (lodash.isString(content) || lodash.isBoolean(content)) {
        return (
          <React.Fragment>
            <strong>{fieldVal}</strong>
            {': '}
            {lodash.isString(content)
              ? content
              : content === true
              ? 'Sim'
              : 'Não'}
          </React.Fragment>
        )
      }

      if (lodash.isArray(content)) {
        return (
          <React.Fragment>
            <strong>{fieldVal.name}</strong>
            {lodash.map(content, (itemChild, i) => (
              <ul key={i.toString()}>
                <li>
                  {lodash.isString(itemChild)
                    ? itemChild
                    : renderFields(itemChild, fieldVal.fields)}
                </li>
              </ul>
            ))}
          </React.Fragment>
        )
      }

      return null
    }

    const renderProcessContent = (info, fieldVal) => {
      return (
        <div style={{ marginLeft: 10 }}>
          {lodash.map(info, (item, i) => (
            <div
              key={i.toString()}
              style={{
                paddingBottom: 10,
                paddingTop: 10,
                borderBottom: '1px solid #ddd',
              }}
            >
              {renderFields(item, fieldVal.fields)}
            </div>
          ))}
        </div>
      )
    }

    return (
      <React.Fragment>
        {lodash.map(infos.options.fields, (fieldVal, fieldKey) => {
          const info = lodash.get(otherInfos, fieldKey)

          return (
            <React.Fragment key={fieldKey}>
              {renderProcessContent(info, fieldVal)}
            </React.Fragment>
          )
        })}
      </React.Fragment>
    )
  }

  return (
    <div className={classes.expansibleContent}>
      <span className={classes.title}>{title}</span>

      <div className={classes.processHeadInfo}>
        { 
          otherInfos.cpf && (
            <React.Fragment>
              <span>
                <b>CPF: </b>
                {otherInfos.cpf}
              </span>
              { otherInfos.envolved_kind && (
                <span>
                  <b>Tipo Envolvido: </b>
                  {otherInfos.envolved_kind === "POLE_PASSIVE" ? "Polo Passivo" : ''}
                </span>
              )}
            </React.Fragment>
          )
        } 
        <span>
          <b>Número de Processos: </b>
          {otherInfos.total_processes}
        </span>
      </div>

      <span>Lista de processos:</span>
      {renderOtherInfos()}
    </div>
  )
}

export default ProcessRow
